export default __webpack_public_path__ + "static/media/assistance-request.b798d3da.png";